<div class="hotels-wrapper">
  @for (hotel of displayedHotels; track hotel) {
    <div
      class="hotel"
      (click)="toggleHotelView(hotel)"
      [ngClass]="getHotelStatus(hotel)"
    >
      <div class="main-info">
        <div class="hotel-name">{{ hotel.hotel_name }}</div>
        <div class="contact-name">{{ hotel.contact_name }}</div>
        <div class="period">{{ hotel.period }}</div>
        <div class="fee">
          <span>{{ hotel.net_price | number: "1.0-2" }} </span>
          <span>{{ hotel.currency }}</span>
        </div>
        <button (click)="signInToHotel(hotel, $event)">
          <i class="login-icon"></i>
        </button>
      </div>
      <div class="extra-info">
        <div class="row">
          <span>{{ hotel.company_name }}</span>
          <span
            class="underline"
            (click)="copyText(hotel.tax_number, $event)"
            >{{ hotel.tax_number }}</span
          >
        </div>

        <div class="row">
          <span class="underline" (click)="copyText(hotel.email, $event)">{{
            hotel.email
          }}</span>
          <span>{{ hotel.phone }}</span>
        </div>

        <div class="row">
          <span>Hotels: {{ hotel.hotels }}</span>
          <span>Rooms: {{ hotel.rooms }}</span>
        </div>

        <div class="row">
          <span>Hotel id: {{ hotel.hotel_id }}</span>
          <span>Invoice: {{ hotel.invoicing }}</span>
        </div>

        <div class="row">
          <span>Channel manager: {{ hotel.channel_manager }}</span>
          <span>Calendar sync: {{ hotel.calendar_sync }}</span>
        </div>
      </div>
    </div>
  }
</div>
